import React from "react";
import { IconSize, IconProps } from "../theme";

const Wallet: React.FC<IconProps> = ({ size = IconSize.M }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame">
        <path
          id="Vector"
          d="M27 9H7C6.73478 9 6.48043 8.89464 6.29289 8.70711C6.10536 8.51957 6 8.26522 6 8C6 7.73478 6.10536 7.48043 6.29289 7.29289C6.48043 7.10536 6.73478 7 7 7H24C24.2652 7 24.5196 6.89464 24.7071 6.70711C24.8946 6.51957 25 6.26522 25 6C25 5.73478 24.8946 5.48043 24.7071 5.29289C24.5196 5.10536 24.2652 5 24 5H7C6.20435 5 5.44129 5.31607 4.87868 5.87868C4.31607 6.44129 4 7.20435 4 8V24C4 24.7956 4.31607 25.5587 4.87868 26.1213C5.44129 26.6839 6.20435 27 7 27H27C27.5304 27 28.0391 26.7893 28.4142 26.4142C28.7893 26.0391 29 25.5304 29 25V11C29 10.4696 28.7893 9.96086 28.4142 9.58579C28.0391 9.21071 27.5304 9 27 9ZM22.5 19C22.2033 19 21.9133 18.912 21.6666 18.7472C21.42 18.5824 21.2277 18.3481 21.1142 18.074C21.0007 17.7999 20.9709 17.4983 21.0288 17.2074C21.0867 16.9164 21.2296 16.6491 21.4393 16.4393C21.6491 16.2296 21.9164 16.0867 22.2074 16.0288C22.4983 15.9709 22.7999 16.0007 23.074 16.1142C23.3481 16.2277 23.5824 16.42 23.7472 16.6666C23.912 16.9133 24 17.2033 24 17.5C24 17.8978 23.842 18.2794 23.5607 18.5607C23.2794 18.842 22.8978 19 22.5 19Z"
          fill="#071443"
        />
      </g>
    </svg>
  );
};

export default Wallet;
